var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 0L27 10.6667V28.2667C27 30.3285 25.3076 32 23.22 32H3.78C1.69236 32 0 30.3285 0 28.2667V3.73333C0 1.67147 1.69236 0 3.78 0H16.2Z",
    fill: "url(#paint0_linear_448_54110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 10.667H20.1709C18.0833 10.667 16.2 8.80696 16.2 6.7451V0.000325203L27 10.667Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3683 26.6671H10.1548V22.6627H11.1131V22.0243H10.1503V21.5109C10.1503 21.0511 10.3537 20.8278 10.7786 20.8278C10.9097 20.8278 11.0407 20.8412 11.1357 20.8546V20.2252C11.0227 20.2073 10.8328 20.1895 10.6565 20.1895C9.78867 20.1895 9.3683 20.6136 9.3683 21.5064V22.0243H8.71289V22.6627H9.3683V26.6671Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3606 21.1984C12.6363 21.1984 12.8533 20.9796 12.8533 20.7118C12.8533 20.4395 12.6363 20.2252 12.3606 20.2252C12.0894 20.2252 11.8679 20.4395 11.8679 20.7118C11.8679 20.9796 12.0894 21.1984 12.3606 21.1984ZM11.9674 26.6671H12.7539V22.0243H11.9674V26.6671Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7552 28.4171C17.0525 28.4171 17.8796 27.6805 17.8796 26.5734V22.0243H17.1293V22.8055H17.1157C16.8039 22.2653 16.2524 21.9439 15.5879 21.9439C14.372 21.9439 13.5855 22.8725 13.5855 24.3278C13.5855 25.7698 14.372 26.7028 15.5699 26.7028C16.2298 26.7028 16.7858 26.3725 17.0751 25.868H17.0931V26.6002C17.0931 27.2921 16.6004 27.7564 15.7868 27.7564C15.1992 27.7564 14.7336 27.4752 14.58 27.0511H13.7709C13.902 27.8412 14.7201 28.4171 15.7552 28.4171ZM15.7281 26.0198C14.919 26.0198 14.3901 25.368 14.3901 24.3278C14.3901 23.2877 14.919 22.627 15.7281 22.627C16.5462 22.627 17.0931 23.3055 17.0931 24.3278C17.0931 25.3502 16.5462 26.0198 15.7281 26.0198Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_54110",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC3CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig);
export default __webpack_public_path__ + "static/media/fig.1462cb71586171824d2d30f046d7fbc4.svg";
export { ForwardRef as ReactComponent };